import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { RichText, Steps, rich } from '../ui';
export function useGuideText() {
    const { t } = useTranslation();
    const str = (key) => {
        const v = t(key, { defaultValue: '' });
        return typeof v === 'string' ? v : '';
    };
    const arr = (key) => {
        const v = t(key, { returnObjects: true, defaultValue: [] });
        return Array.isArray(v) ? v : [];
    };
    return { t, str, arr };
}
/** Ein oder mehrere Absätze aus einem Schlüssel (Leerzeile trennt Absätze). */
export const P = ({ k, className }) => {
    const { str } = useGuideText();
    const text = str(k);
    return text ? _jsx(RichText, { text: text, className: className }) : null;
};
/** Inline-Text mit Markup, ohne Absatz. */
export const Inline = ({ k }) => {
    const { str } = useGuideText();
    return _jsx(_Fragment, { children: rich(str(k)) });
};
/** Nummerierte Schritte aus einem String-Array. */
export const StepsFrom = ({ k }) => {
    const { arr } = useGuideText();
    const items = arr(k);
    if (!items.length)
        return null;
    return (_jsx(Steps, { children: items.map((s, i) => (_jsx("p", { children: rich(s) }, i))) }));
};
/** Aufzählung aus einem String-Array. */
export const ListFrom = ({ k }) => {
    const { arr } = useGuideText();
    const items = arr(k);
    if (!items.length)
        return null;
    return (_jsx("ul", { children: items.map((s, i) => (_jsx("li", { children: rich(s) }, i))) }));
};
/** Begriff/Erklärung-Liste aus einem Array von { term, text }. */
export const RowsFrom = ({ k, termAs = 'plain' }) => {
    const { arr } = useGuideText();
    const rows = arr(k);
    if (!rows.length)
        return null;
    return (_jsx("dl", { className: "def-list", children: rows.map((r, i) => (_jsxs("div", { children: [_jsx("dt", { children: termAs === 'code' ? _jsx("code", { children: r.term }) : r.term }), _jsx("dd", { children: _jsx(RichText, { text: r.text }) })] }, i))) }));
};
/** Beispielbild mit Bildunterschrift (Text aus i18n). "watch" = freigestellte Uhr, "wide" = volle Breite. */
export const Figure = ({ src, captionKey, variant = 'watch', width, height, }) => {
    const { str } = useGuideText();
    const caption = str(captionKey);
    return (_jsxs("figure", { className: `guide-figure guide-figure-${variant}`, children: [_jsx("img", { src: src, alt: caption, width: width, height: height, loading: "lazy" }), caption && _jsx("figcaption", { children: caption })] }));
};
